import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Loader2, CheckCircle2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { LogoWordmark } from "../components/Logo";

export default function Register() {
    const { register } = useAuth();
    const navigate = useNavigate();
    const [form, setForm] = useState({
        name: "",
        email: "",
        phone: "",
        company: "",
        password: "",
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError("");
        const res = await register(form);
        setLoading(false);
        if (res.ok) setSuccess(true);
        else setError(res.error);
    };

    if (success)
        return (
            <div className="min-h-screen flex items-center justify-center p-6 bg-[#f7f7f5] grid-bg">
                <div
                    className="bg-white rounded-3xl border border-gray-100 shadow-xl max-w-lg w-full p-10 text-center fade-up"
                    data-testid="register-success"
                >
                    <div className="w-16 h-16 rounded-full bg-[#C7FF2C] mx-auto flex items-center justify-center mb-6">
                        <CheckCircle2 className="w-8 h-8 text-[#0C4650]" />
                    </div>
                    <h1 className="text-3xl font-extrabold text-[#0C4650]">Richiesta inviata</h1>
                    <p className="mt-3 text-gray-600">
                        Il tuo profilo è in attesa di approvazione. Riceverai accesso non appena
                        l'amministratore avrà abilitato il tuo account.
                    </p>
                    <button
                        onClick={() => navigate("/login")}
                        className="btn-primary mt-8"
                        data-testid="register-success-back"
                    >
                        Torna al login
                    </button>
                </div>
            </div>
        );

    return (
        <div className="min-h-screen flex items-center justify-center p-6 bg-[#f7f7f5] grid-bg">
            <div className="w-full max-w-xl bg-white rounded-3xl border border-gray-100 shadow-xl p-8 sm:p-10 fade-up">
                <LogoWordmark />
                <div className="mt-8">
                    <h1 className="text-3xl sm:text-4xl font-extrabold text-[#0C4650]">
                        Richiedi l'abilitazione
                    </h1>
                    <p className="mt-2 text-gray-600">
                        Compila i tuoi dati. Riceverai l'accesso dopo la verifica dello staff
                        Scintilla Hub.
                    </p>

                    <form onSubmit={submit} className="mt-6 space-y-4" data-testid="register-form">
                        <div className="grid sm:grid-cols-2 gap-4">
                            <div>
                                <label className="label">Nome e cognome *</label>
                                <input
                                    className="field"
                                    value={form.name}
                                    onChange={(e) => setForm({ ...form, name: e.target.value })}
                                    required
                                    data-testid="register-name"
                                />
                            </div>
                            <div>
                                <label className="label">Telefono WhatsApp *</label>
                                <input
                                    className="field"
                                    value={form.phone}
                                    onChange={(e) => setForm({ ...form, phone: e.target.value })}
                                    required
                                    placeholder="+39 333 1234567"
                                    data-testid="register-phone"
                                />
                            </div>
                        </div>
                        <div>
                            <label className="label">Email *</label>
                            <input
                                type="email"
                                className="field"
                                value={form.email}
                                onChange={(e) => setForm({ ...form, email: e.target.value })}
                                required
                                data-testid="register-email"
                            />
                        </div>
                        <div>
                            <label className="label">Azienda / P.IVA</label>
                            <input
                                className="field"
                                value={form.company}
                                onChange={(e) => setForm({ ...form, company: e.target.value })}
                                data-testid="register-company"
                            />
                        </div>
                        <div>
                            <label className="label">Password *</label>
                            <input
                                type="password"
                                className="field"
                                value={form.password}
                                onChange={(e) => setForm({ ...form, password: e.target.value })}
                                required
                                minLength={6}
                                data-testid="register-password"
                                placeholder="min. 6 caratteri"
                            />
                        </div>

                        {error && (
                            <div
                                className="bg-rose-50 border border-rose-200 text-rose-700 rounded-lg px-4 py-3 text-sm"
                                data-testid="register-error"
                            >
                                {error}
                            </div>
                        )}

                        <button
                            type="submit"
                            disabled={loading}
                            className="btn-primary w-full"
                            data-testid="register-submit"
                        >
                            {loading && <Loader2 className="w-4 h-4 animate-spin" />}
                            Invia richiesta
                        </button>
                    </form>

                    <div className="mt-6 text-sm text-gray-600">
                        Hai già un profilo?{" "}
                        <Link
                            to="/login"
                            className="font-bold text-[#0C4650] underline underline-offset-4"
                            data-testid="go-login"
                        >
                            Accedi
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
}
